import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=a7c7d2a2"
import script from "./DeleteUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports